import { useMemo, useState } from "react";
import { AddCompaniesSidebar } from "./AddCompaniesSidebar/ui/AddCompaniesSidebar";
import styles from "./AddCompaniesPage.module.scss";
import { InnoveraHeader } from "../../InnoveraHeader";
import { sections } from "./AddCompaniesSidebar/const/const";
import { CompanySection } from "./CompanySection/ui/CompanySection";
import { CompetitorsSection } from "./CompetitorsSection/ui/CompetitorsSection";
import { DataroomSection } from "./DataroomSection/ui/Dataroom";
import { ProductsSection } from "./ProductsSection/ui/ProductsSection";
import { postCreateEmptyCompany } from "../model/services/postCreateEmptyCompany";
import { patchUpdateCompanyDetails } from "../model/services/patchUpdateCompanyDetails";
import { TFormData } from "./CompanySection/types/companySectionTypes";
import { postCreatePortfolioCompany } from "../model/services/postCreatePortfolioCompany";
import { TCompanyDetailsUpdate } from "../types/types";
import { OrganizeSection } from "./OrganizeSection/ui/OrganizeSection";
import { MetricsSection } from "./MetricsSection/ui/MetricsSection";
import { TeamSection } from "./TeamSection/ui/TeamSection";

export function AddCompaniesPage() {
  const [activeItem, setActiveItem] = useState("Company");
  const activeIndex = sections.findIndex((item) => item.itemName === activeItem);
  const passedItems = sections.filter((_, index) => index < activeIndex);
  const [data, setData] = useState<TFormData | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const activeSection = useMemo(() => {
    switch (activeItem) {
      case "Company":
        return (
          <CompanySection setNewData={setData} createCompanyHandler={createCompanyHandler} isLoading={isLoading} />
        );
      case "Products":
        return <ProductsSection />;
      case "Competitors":
        return <CompetitorsSection />;
      case "Data Room":
        return <DataroomSection />;
      case "Organize":
        return <OrganizeSection />;
      case "Metrics":
        return <MetricsSection />;
      case "Team":
        return <TeamSection />;
      default:
        return null;
    }
  }, [activeItem, createCompanyHandler, setData]);

  async function createCompanyHandler() {
    setIsLoading(true);
    try {
      const emptyCompanyId = await postCreateEmptyCompany();
      await patchUpdateCompanyDetails(emptyCompanyId, {
        name: data?.name,
        headline: data?.headline,
        description: data?.description,
        logoBase64: data?.companyLogo,
        website: data?.website,
        // foundingDate: data?.selectedYearValue ? new Date(data.selectedYearValue) : undefined,
        country: data?.selectedRegionValue,
        state: data?.selectedLocationValue,
        city: data?.selectedLocationValue,
        facebookUrl: data?.facebookValue,
        linkedInUrl: data?.linkedInValue,
        angelListUrl: data?.angelListValue,
        githubUrl: data?.githubValue,
        instagramUrl: data?.instagramValue,
        twitterUrl: data?.xTwitterValue,
        productHuntUrl: data?.productHuntValue

        // currencyId: data?.selectedCurrencyValue ? parseInt(data.selectedCurrencyValue) : undefined

        // totalFunding: data?.totalFundingValue ? data.totalFundingValue.toString() : undefined,
        // valuation: data?.lastValuationValue ? data.lastValuationValue.toString() : undefined,
        // tam: data?.tamValue ? data.tamValue.toString() : undefined,
        // sam: data?.samValue ? data.samValue.toString() : undefined,
        // som: data?.somValue ? data.somValue.toString() : undefined,

        //   teamSize: data?.teamSizeValue,
        //   targetMarkets: data?.targetMarketsValue,
        //   industries: data?.industriesValue,
        //   tags: data?.tagsValue,
        //   founders: data?.foundersData?.founders.map((founder) => ({
        //     image: founder.image,
        //     firstName: founder.firstName,
        //     lastName: founder.lastName,
        //     title: founder.title,
        //     bio: founder.bio,
        //     linkedIn: founder.linkedIn
        //   })),
        //   investors: data?.investors.map((investor) => ({
        //     image: investor.image,
        //     name: investor.name,
        //     investorRound: investor.investorRound,
        //     investorStage: investor.investorStage
        //     // investorAmount: BigInt(investor.investorAmount).toString(),
        //     // investorValuation: BigInt(investor.investorValuation).toString()
        //   })
        // )
      } as TCompanyDetailsUpdate);

      await postCreatePortfolioCompany(emptyCompanyId);
      // setData(null);
      setActiveItem("Products");
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.container}>
      <InnoveraHeader className={styles.innoveraHeader} />
      <div className={styles.content}>
        <div className={styles.leftsideContainer}>
          <AddCompaniesSidebar
            activeItem={activeItem}
            passedItems={passedItems}
            className={styles.sidebar}
            setItem={setActiveItem}
          />
        </div>
        <div className={styles.activeSection}>{activeSection}</div>
      </div>
    </div>
  );
}
